import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import AccediRegistrati from "@/pages/AccediRegistrati";
import Profilo from "@/pages/Profilo";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TerminiServizio from "@/pages/TerminiServizio";
import CookieBanner from "@/components/CookieBanner";

function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-labor-bg">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <Chatbot />
      <CookieBanner />
    </div>
  );
}

function AdminLayout() {
  return (
    <div className="min-h-screen bg-labor-bg">
      <div className="border-b border-labor-border bg-white px-6 py-4">
        <div className="font-display text-xl text-labor-olive">Labor · Area Staff</div>
      </div>
      <Outlet />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  // Emergent Google Auth returns to /profilo#session_id=...
  // Detect during render (not effect) to avoid race with route guard
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/servizi" element={<Services />} />
        <Route path="/prenota" element={<Booking />} />
        <Route path="/news" element={<News />} />
        <Route path="/contatti" element={<Contact />} />
        <Route path="/accedi" element={<AccediRegistrati mode="login" />} />
        <Route path="/registrati" element={<AccediRegistrati mode="register" />} />
        <Route path="/profilo" element={<Profilo />} />
        <Route path="/pagamento/successo" element={<PaymentSuccess />} />
        <Route path="/pagamento/annullato" element={<PaymentCancel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/termini-di-servizio" element={<TerminiServizio />} />
      </Route>
      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
